import React from 'react';
import { Grid, Box, Tooltip } from '@mui/material';
import { TextField, Switches } from '@occc-app/design-system';
import { Typography, TuneIcon, InfoOutlinedIcon, IconButton } from '@occc/ui-design-system';
import { parseNumber } from '@occc-app/lib/finalFormUtils';
import { LimitFormContentLayout } from '@occc/feat-limits';
import { VOUCHER_RESTRICTION_TOOLTIP_MESSAGE } from './constants';

export interface VoucherExpirationDaysRedemptionProps {
  isVoucherRedemptionEnabled: boolean;
  isVoucherRedemptionApplicable: boolean;
  showAvatar?: boolean;
  disabledTooltipMessage?: string;
  fieldNamePrefix?: string;
}

export const VoucherExpirationDaysRedemption: React.FC<VoucherExpirationDaysRedemptionProps> = ({
  isVoucherRedemptionEnabled: checked,
  isVoucherRedemptionApplicable,
  showAvatar,
  disabledTooltipMessage: disabledTooltip = VOUCHER_RESTRICTION_TOOLTIP_MESSAGE,
  fieldNamePrefix = '',
}) => {
  const prefix = fieldNamePrefix ? `${fieldNamePrefix}.` : '';

  return (
    <LimitFormContentLayout
      title='Add Award Expiration'
      action={
        <Box display='flex' alignItems='center' gap={1}>
          <Switches
            name={`${prefix}awardVouchers.isEnabled`}
            data={{}}
            switchProps={{ disabled: !isVoucherRedemptionApplicable }}
          />
          {!isVoucherRedemptionApplicable && (
            <Tooltip title={disabledTooltip} arrow>
              <IconButton size='small' aria-label='Redemption restrictions info'>
                <InfoOutlinedIcon fontSize='small' />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      }
      open={checked && isVoucherRedemptionApplicable}
      avatar={showAvatar ? TuneIcon : undefined}
    >
      <Grid container spacing={2} alignItems='center'>
        <Grid item xs={3}>
          <TextField
            name={`${prefix}awardVouchers.voucherExpirationDays`}
            label='Days left'
            disabled={!isVoucherRedemptionApplicable}
            fieldProps={{ parse: parseNumber }}
          />
        </Grid>
        <Grid item>
          <Typography>days to fulfill award after award granted</Typography>
        </Grid>
      </Grid>
    </LimitFormContentLayout>
  );
};
